import {
  ADD_TO_CART_CLICKED,
  ADD_TO_CART_ERROR,
  ADD_TO_CART_SUBMITTED,
  ANGLE_SELECTED,
  BACKGROUND_CLICKED,
  BACKGROUND_IMAGE_UPLOADED,
  BACKGROUND_REMOVE_IMAGE,
  BACKGROUND_SET_MODE,
  BACKGROUND_SET_COLOR,
  BASE_MODEL_CLICKED,
  BASE_MODEL_SET,
  BIKE_CONFIG_SET_PARAMS,
  BIKE_IMAGE_LOADED,
  BIKE_IMAGE_LOADING,
  CLOSE_POPOVER,
  COMPONENT_CLICKED,
  COMPONENT_HOVERED,
  COMPONENT_TOGGLE,
  COMPONENT_HIGHLIGHTED,
  COMPONENT_UNHIGHLIGHTED,
  CUSTOM_COLOR_CHOSEN,
  FULL_PAINT_CLICKED,
  FULL_PAINT_SET_RAL,
  INFO_CLICKED,
  INITIALS_SET,
  INQUIRY_CLICKED,
  INQUIRY_ERROR,
  INQUIRY_SET_FROM_EMAIL,
  INQUIRY_SET_FROM_NAME,
  INQUIRY_SET_FROM_PHONE,
  INQUIRY_SET_FROM_ADDRESS,
  INQUIRY_SET_MESSAGE,
  INQUIRY_SUBMITTED,
  INQUIRY_SUCCESS,
  LOGO_CLICKED,
  LOGO_REMOVE,
  LOGO_UPLOADED,
  NEXT_CLICKED,
  OPTION_CLICKED,
  OPTION_SELECTED,
  PDF_CLICKED,
  PRESETS_CLICKED,
  VIDEO_CLICKED,
  QUANTITY_SET,
  SHARE_CLICKED,
  SHARE_ERROR,
  SHARE_SET_FROM_EMAIL,
  SHARE_SET_FROM_NAME,
  SHARE_SET_MESSAGE,
  SHARE_SET_TO_EMAIL,
  SHARE_SET_TO_NAME,
  SHARE_SUBMITTED,
  SHARE_SUCCESS,
  SPECIFICATION_CLICKED,
  SPECIFICATIONS_CLICKED,
  UNDO_CLICKED,
  SETTINGS_CLICKED,
  RESET_UNDO,
  DISCLAIMER_CLICKED,
  CART_DISCLAIMER_CLICKED,
  GET_QUOTE_CLICKED,
  GET_QUOTE_ERROR,
  GET_QUOTE_SET_QUANTITY,
  GET_QUOTE_SET_COMPANY_NAME,
  GET_QUOTE_SET_COMPANY_ADDRESS_LINE1,
  GET_QUOTE_SET_COMPANY_ADDRESS_LINE2,
  GET_QUOTE_SET_COMPANY_COUNTRY,
  GET_QUOTE_SET_COMPANY_VAT_NO,
  GET_QUOTE_SET_COMPANY_EMAIL,
  GET_QUOTE_SET_COMPANY_TELEPHONE,
  GET_QUOTE_SET_CONTACT_PERSON,
  GET_QUOTE_SET_COMMENTS,
  GET_QUOTE_SUBMITTED,
  GET_QUOTE_SUCCESS
} from './actions'
import {
  getBaseModel,
  getComponent,
  getOption,
  getDefaultPopover,
  listColors,
  listUrbanChicGentsColors,
  listUrbanChicLadiesColors
} from './utils/bike-schema'
import { hoverList, toggleList, BACKEND_URL } from './utils/settings'

import {
  bikeConfigFromParams,
  putAllChoiceColors,
  putChoice,
  putAngle,
  putBackgroundImage,
  deleteBackgroundImage,
  putBackgroundColor,
  putBackgroundMode
} from './utils/bike-config'

import {
  checkCompatible,
  parseIntWithFallback,
  formatHistory
} from './utils/reducer-utils'
import { Color } from 'bike-schema'
import { State, Option } from 'shared'

const reducers = (state: State, action): any => {
  switch (action.type) {
    case ADD_TO_CART_CLICKED:
      return {
        ...state,
        popover: 'addToCart'
      }

    case ADD_TO_CART_ERROR:
      return {
        ...state,
        addToCart: {
          ...state.addToCart,
          submitting: false,
          errors: action.errors
        }
      }

    case ADD_TO_CART_SUBMITTED:
      return {
        ...state,
        addToCart: {
          ...state.addToCart,
          submitting: true,
          cartDisclaimer: true
        }
      }

    case BACKGROUND_CLICKED:
      return {
        ...state,
        popover: 'background'
      }

    case BACKGROUND_IMAGE_UPLOADED:
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: putBackgroundImage(state.bikeConfig, action.url)
      }

    case BACKGROUND_REMOVE_IMAGE:
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: deleteBackgroundImage(state.bikeConfig)
      }

    case BACKGROUND_SET_COLOR:
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: putBackgroundColor(state.bikeConfig, action.value)
      }

    case BACKGROUND_SET_MODE:
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: putBackgroundMode(state.bikeConfig, action.value)
      }

    case BASE_MODEL_CLICKED:
      return {
        ...state,
        popover: 'baseModels',
        defaultLogo: true
      }

    case BASE_MODEL_SET: {
      const params = {
        base_model_id: action.baseModelId,
        angle: action.baseModelId.includes('cargo') ? 'right' : 'none'
      }
      return {
        ...state,
        bikeConfigPristine: true,
        bikeConfig: bikeConfigFromParams(params),
        bikeImage: {
          ...state.bikeImage,
          loaded: false,
          loading: false,
          highlightedComponentId: null,
          choices: []
        },
        specifications: false,
        popover: getDefaultPopover(action.baseModelId),
        fullHistory: [],
        undoCounter: 0,
        undoed: false
      }
    }

    case BIKE_CONFIG_SET_PARAMS: {
      const updatedHistory = formatHistory(state)

      return {
        ...state,
        bikeConfigPristine: true,
        bikeConfig: bikeConfigFromParams(action.params),
        popover: null,
        undoCounter: 0,
        undoed: 0,
        fullHistory: updatedHistory
      }
    }

    case BIKE_IMAGE_LOADED: {
      let updatedChoices = state.bikeConfig
      return {
        ...state,
        bikeConfig: updatedChoices,
        bikeImage: {
          ...state.bikeImage,
          loaded: true,
          loading: false,
          choices: action.choices,
          logos: action.logos
        }
      }
    }

    case BIKE_IMAGE_LOADING:
      return {
        ...state,
        bikeImage: {
          ...state.bikeImage,
          loading: true
        }
      }

    case CLOSE_POPOVER:
      return {
        ...state,
        popover: null
      }

    case COMPONENT_CLICKED:
      const baseModel = getBaseModel(state.bikeConfig.baseModelId)
      const component = getComponent(baseModel, action.componentId)
      let customColorOption: Option | null = null
      if (
        component?.options.length === 1 &&
        component.options[0].custom_color
      ) {
        customColorOption = component.options[0]
      }
      if (customColorOption) {
        return {
          ...state,
          popover: 'optionColor',
          optionColor: {
            componentId: action.componentId,
            optionId: customColorOption.id
          }
        }
      }
      if (
        (state.popover === 'componentHover' || state.popover === null) &&
        hoverList.find((item) => item === action.componentId) &&
        window.innerWidth >= 768
      ) {
        return {
          ...state,
          popover: 'componentHover',
          options: {
            componentId: action.componentId
          }
        }
      } else {
        return {
          ...state,
          popover: 'options',
          options: {
            componentId: action.componentId
          }
        }
      }

    case COMPONENT_HOVERED: {
      const baseModel = getBaseModel(state.bikeConfig.baseModelId)
      const component = getComponent(baseModel, action.componentId)
      // hoverList: allowed components to display current options when hovered on a component
      if (
        (state.popover === 'componentHover' || state.popover === null) &&
        hoverList.find((item) => item === action.componentId) &&
        window.innerWidth >= 768
      ) {
        return {
          ...state,
          popover: 'componentHover',
          options: {
            componentId: action.componentId
          }
        }
      } else {
        return {
          ...state
        }
      }
    }

    case COMPONENT_TOGGLE: {
      const baseModel = getBaseModel(state.bikeConfig.baseModelId)
      const components = baseModel?.components
        .map((item) => toggleList.find((el) => el === item.id) && item)
        .filter((el) => el != null)

      return {
        ...state,
        popover: 'componentToggle',
        components
      }
    }

    case COMPONENT_HIGHLIGHTED:
      return {
        ...state,
        bikeImage: {
          ...state.bikeImage,
          highlightedComponentId: action.componentId
        }
      }

    case COMPONENT_UNHIGHLIGHTED:
      return {
        ...state,
        bikeImage: {
          ...state.bikeImage,
          highlightedComponentId: null
        }
      }

    case DISCLAIMER_CLICKED:
      return {
        ...state,
        disclaimer: true
      }

    case CART_DISCLAIMER_CLICKED:
      return {
        ...state,
        cartDisclaimer: true
      }

    case FULL_PAINT_CLICKED:
      return {
        ...state,
        popover: 'fullPaint'
      }

    case FULL_PAINT_SET_RAL: {
      const updatedHistory = formatHistory(state)
      return {
        ...state,
        bikeConfigPristine: true,
        bikeConfig: putAllChoiceColors(
          state.bikeConfig,
          action.ral,
          state.defaultLogo
        ),
        popover: null,
        fullHistory: updatedHistory,
        undoCounter: 0,
        undoed: 0
      }
    }

    case GET_QUOTE_CLICKED:
      return {
        ...state,
        popover: 'getQuote',
        getQuote: {
          ...state.getQuote,
          done: false
        }
      }

    case GET_QUOTE_ERROR:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          submitting: false,
          errors: action.errors
        }
      }

    case GET_QUOTE_SET_QUANTITY:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          quantity: action.quantity
        }
      }

    case GET_QUOTE_SET_COMPANY_NAME:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyName: action.companyName
        }
      }

    case GET_QUOTE_SET_COMPANY_ADDRESS_LINE1:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyAddressLine1: action.companyAddressLine1
        }
      }

    case GET_QUOTE_SET_COMPANY_ADDRESS_LINE2:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyAddressLine2: action.companyAddressLine2
        }
      }

    case GET_QUOTE_SET_COMPANY_COUNTRY:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyCountry: action.companyCountry
        }
      }

    case GET_QUOTE_SET_COMPANY_VAT_NO:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyVatNo: action.companyVatNo
        }
      }

    case GET_QUOTE_SET_COMPANY_EMAIL:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyEmail: action.companyEmail
        }
      }

    case GET_QUOTE_SET_COMPANY_TELEPHONE:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          companyTelephone: action.companyTelephone
        }
      }

    case GET_QUOTE_SET_CONTACT_PERSON:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          contactPerson: action.contactPerson
        }
      }

    case GET_QUOTE_SET_COMMENTS:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          comments: action.comments
        }
      }

    case GET_QUOTE_SUBMITTED:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          submitting: true
        }
      }

    case GET_QUOTE_SUCCESS:
      return {
        ...state,
        getQuote: {
          ...state.getQuote,
          errors: null,
          quantity: 1,
          companyName: '',
          companyAddressLine1: '',
          companyAddressLine2: '',
          companyCountry: '',
          companyVatNo: '',
          companyEmail: '',
          companyTelephone: '',
          contactPerson: '',
          comments: '',
          submitting: false,
          done: true
        }
      }

    case LOGO_CLICKED:
      return {
        ...state,
        popover: 'logo'
      }

    case LOGO_REMOVE: {
      let data: any = {
        logo: null
      }
      if (action.logoAngle === 'right') {
        data = {
          logo_right: null
        }
      }
      if (action.logoAngle === 'left') {
        data = {
          logo_left: null
        }
      }
      if (action.logoAngle === 'front') {
        data = {
          logo_front: null
        }
      }

      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: putChoice(state.bikeConfig, action.componentId, data),
        defaultLogo: false
      }
    }

    case LOGO_UPLOADED:
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: putChoice(
          state.bikeConfig,
          action.componentId,
          action.data
        ),
        defaultLogo: false
      }

    case INFO_CLICKED:
      return {
        ...state,
        popover: 'info'
      }

    case INITIALS_SET:
      return {
        ...state,
        bikeConfig: {
          ...state.bikeConfig,
          initials: action.value
        }
      }

    case INQUIRY_CLICKED:
      return {
        ...state,
        popover: 'inquiry',
        inquiry: {
          ...state.inquiry,
          done: false
        }
      }

    case INQUIRY_ERROR:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          submitting: false,
          errors: action.errors
        }
      }

    case INQUIRY_SET_FROM_EMAIL:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          fromEmail: action.value
        }
      }

    case INQUIRY_SET_FROM_PHONE:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          fromPhone: action.value
        }
      }

    case INQUIRY_SET_FROM_ADDRESS:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          fromAddress: action.value
        }
      }

    case INQUIRY_SET_FROM_NAME:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          fromName: action.value
        }
      }

    case INQUIRY_SET_MESSAGE:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          message: action.value
        }
      }

    case INQUIRY_SUBMITTED:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          submitting: true
        }
      }

    case INQUIRY_SUCCESS:
      return {
        ...state,
        inquiry: {
          ...state.inquiry,
          errors: null,
          fromEmail: '',
          fromName: '',
          message: '',
          submitting: false,
          done: true
        }
      }

    case NEXT_CLICKED: {
      let colorList: Color[] = []
      if (state.bikeConfig.baseModelId.startsWith('urban')) {
        colorList =
          state.bikeConfig.baseModelId.endsWith('chic-gents') ||
          state.bikeConfig.baseModelId.endsWith('chic-top-gents')
            ? listUrbanChicGentsColors()
            : listUrbanChicLadiesColors()
      } else colorList = listColors()

      const frameRal = state.bikeConfig.choices.find(
        ({ componentId }) => componentId === 'frame'
      )?.ral

      let colorIndex = colorList.findIndex(({ ral }) => ral === frameRal)

      if (colorIndex === colorList.length - 1 && action.next) {
        colorIndex = 0
      } else if (colorIndex === 0 && !action.next) {
        colorIndex = colorList.length - 1
      } else {
        if (action.next) colorIndex++
        else colorIndex--
      }

      const newColor = colorList[colorIndex].ral
      const updatedHistory = formatHistory(state)

      return {
        ...state,
        bikeConfigPristine: true,
        bikeConfig: putAllChoiceColors(
          state.bikeConfig,
          newColor,
          state.defaultLogo
        ),
        popover: action.fullPaintPopoverOpen ? 'fullPaint' : null,
        fullHistory: updatedHistory,
        undoCounter: 0,
        undoed: 0
      }
    }

    case OPTION_CLICKED: {
      const baseModel = getBaseModel(state.bikeConfig.baseModelId)
      const component = getComponent(baseModel, action.componentId)

      const { custom_color, compatible } =
        getOption(component, action.optionId) ?? {}
      const isCompatible = checkCompatible(compatible, state.bikeConfig.choices)
      let newPopover: string | null = null
      if (custom_color) newPopover = 'optionColor'
      if (isCompatible) newPopover = 'compatibility'
      if (action.keepOpen) newPopover = 'componentToggle'

      const updatedHistory = formatHistory(state)
      if (custom_color) {
        return {
          ...state,
          popover: newPopover,
          optionColor: {
            componentId: action.componentId,
            optionId: action.optionId
          }
        }
      } else {
        return {
          ...state,
          bikeConfigPristine: false,
          bikeConfig: putChoice(state.bikeConfig, action.componentId, {
            optionId: action.optionId
          }),
          popover: newPopover,
          fullHistory: updatedHistory,
          undoed: false,
          undoCounter: 0
        }
      }
    }

    case ANGLE_SELECTED: {
      putAngle(state.bikeConfig, action.angle)
      return {
        ...state,
        bikeConfig: { ...state.bikeConfig, angle: action.angle },
        popover: null
      }
    }

    case CUSTOM_COLOR_CHOSEN: {
      const updatedHistory = formatHistory(state)
      const uniqueRals = Array.from(
        new Set([action.ral, ...state.latestPickedRals])
      )

      let method
      if (state.bikeConfig.baseModelId.startsWith('urban')) {
        method = putAllChoiceColors(state.bikeConfig, action.ral)
      } else if (action.componentId === 'electric-motor' && state.defaultLogo) {
        const logoColor =
          action.ral === 9005 || action.ral === 9011 ? '-white' : ''
        method = putChoice(state.bikeConfig, action.componentId, {
          optionId: action.optionId,
          ral: action.ral,
          logo: `${BACKEND_URL}/images/logos/battery-logo${logoColor}.png`
        })
      } else {
        method = putChoice(state.bikeConfig, action.componentId, {
          optionId: action.optionId,
          ral: action.ral
        })
      }

      const baseModel = getBaseModel(state.bikeConfig.baseModelId)
      const component = getComponent(baseModel, action.componentId)
      const option = getOption(component, action.optionId)
      const isCompatible = checkCompatible(
        option?.compatible,
        state.bikeConfig.choices
      )
      return {
        ...state,
        bikeConfigPristine: false,
        bikeConfig: method,
        popover: isCompatible ? 'compatibility' : null,
        latestPickedRals: uniqueRals,
        fullHistory: updatedHistory,
        undoed: false,
        undoCounter: 0,
        disclaimer: true
      }
    }

    case OPTION_SELECTED:
      return {
        ...state,
        bikeConfig: putChoice(state.bikeConfig, action.componentId, {
          optionId: action.optionId
        }),
        popover: null
      }

    case PDF_CLICKED:
      return {
        ...state,
        pdfOnly: true
      }

    case PRESETS_CLICKED:
      return {
        ...state,
        popover: 'presets'
      }

    case VIDEO_CLICKED:
      return {
        ...state,
        popover: 'video'
      }

    case QUANTITY_SET:
      return {
        ...state,
        quantity: parseIntWithFallback(action.value, state.quantity),
        quantityRaw: action.value
      }

    case SETTINGS_CLICKED:
      return {
        ...state,
        popover: 'settings'
      }

    case SHARE_CLICKED:
      return {
        ...state,
        popover: 'share',
        share: {
          ...state.share,
          done: false
        }
      }

    case SHARE_ERROR:
      return {
        ...state,
        share: {
          ...state.share,
          submitting: false,
          errors: action.errors
        }
      }

    case SHARE_SET_FROM_EMAIL:
      return {
        ...state,
        share: {
          ...state.share,
          fromEmail: action.value
        }
      }

    case SHARE_SET_FROM_NAME:
      return {
        ...state,
        share: {
          ...state.share,
          fromName: action.value
        }
      }

    case SHARE_SET_TO_EMAIL:
      return {
        ...state,
        share: {
          ...state.share,
          toEmail: action.value
        }
      }

    case SHARE_SET_TO_NAME:
      return {
        ...state,
        share: {
          ...state.share,
          toName: action.value
        }
      }

    case SHARE_SET_MESSAGE:
      return {
        ...state,
        share: {
          ...state.share,
          message: action.value
        }
      }

    case SHARE_SUBMITTED:
      return {
        ...state,
        share: {
          ...state.share,
          submitting: true
        }
      }

    case SHARE_SUCCESS:
      return {
        ...state,
        share: {
          ...state.share,
          errors: null,
          fromEmail: '',
          fromName: '',
          toEmail: '',
          toName: '',
          message: '',
          submitting: false,
          done: true
        }
      }

    case SPECIFICATION_CLICKED:
      return {
        ...state,
        popover: 'specification',
        specification: action.id
      }

    case SPECIFICATIONS_CLICKED:
      return {
        ...state,
        specifications: !state.specifications
      }

    case RESET_UNDO:
      return {
        ...state,
        undoCounter: 0
      }

    case UNDO_CLICKED:
      return {
        ...state,
        fullHistory: !state.undoed
          ? [...state.fullHistory, state.bikeConfig.choices]
          : [...state.fullHistory],
        undoCounter: action.redo
          ? (state.undoCounter -= 1)
          : (state.undoCounter += 1),
        bikeConfig: { ...state.bikeConfig, choices: action.choicesToApply },
        undoed: true
      }

    case 'OPEN_WARNING_POPUP':
      if (window.globalOpenWarningPopup) {
        window.globalOpenWarningPopup.open = false
      }
      return {
        ...state,
        popover: 'uncombinable',
        uncombinables: action.payload
      }

    default:
      return state
  }
}

export default reducers
